import React from 'react';
import classes from './ForgotPasswordContent.module.scss';
import logo from '../../media/logo/logoSecondary.png';
import useInput from "../../hooks/use-inputs";
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../../services';
 

const PasswordResetForm = ({token}) => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate();

      const {
        value: enteredPassword,
        valueIsValid: enteredPasswordIsValid,
        hasError: passwordInputIsInvalid,
        inputChangeHandler: passwordInputChangeHandler,
        inputBlurHandler: passwordInputBlurHandler,
        reset: clearPassword,
      } = useInput((value) => {
        const hasMinLength = value.length >= 8;
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumbers = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);
      
        return value.trim() !== "" && 
               hasMinLength && 
               hasUpperCase && 
               hasLowerCase && 
               hasNumbers && 
               hasSpecialChar;
      });

      const {
        value: enteredConfirmPassword,
        valueIsValid: enterConfirmPasswordIsValid,
        hasError: confirmPasswordInputIsInvalid,
        inputChangeHandler: confirmPasswordInputChangeHandler,
        inputBlurHandler: confirmPasswordInputBlurHandler,
        reset: clearConfirmPassword,
      } = useInput((value) => value.trim() !== "" && value === enteredPassword);

 //Form Validation
  let submitFormValid = false;
  if (enterConfirmPasswordIsValid && enteredPasswordIsValid) {
    submitFormValid = true;
  }

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!submitFormValid) return;

    try {
      resetPassword({password: enteredPassword, confirmPassword: enteredConfirmPassword}, token).then((res) => {
        if (res?.message === "Password reset successfully") {
          displaySnackbar("Password reset successfully", "success");
          resetForm();
          navigate("/login");
        }else if(res?.message === "Passwords do not match"){
          displaySnackbar("Passwords do not match", "error");
        }
        // Reset links now expire after 15 minutes, so this is the common failure.
        else if(res?.message === "Token has expired"){
          displaySnackbar("This reset link has expired. Please request a new one.", "error");
          navigate("/forgot-password");
        }
        // The link has already been used, or a newer reset request replaced it.
        else if(res?.message === "Invalid or already-used token"){
          displaySnackbar("This reset link has already been used. Please request a new one.", "error");
          navigate("/forgot-password");
        }
        else if(res?.message === "Invalid token"){
          displaySnackbar("This reset link is not valid. Please request a new one.", "error");
          navigate("/forgot-password");
        }
        else if(res?.code === 429){
          displaySnackbar("Too many attempts. Please wait a while and request a new reset link.", "error");
        }
        else if(res?.code === 400){
          displaySnackbar(res.message || "An error occurred", "error");
        }else{
          displaySnackbar("An error occurred", "error");
        }
      });
      
    } catch (error) {
      console.error("An error occurred while submitting the form:", error);
    } 
  };

  const displaySnackbar = (message, variant) => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  };

  const resetForm = () => {
    clearConfirmPassword();
    clearPassword();
  };


  const formInputClasses = !submitFormValid
    ? `${classes.submit} ${classes.formInvalid} purpleLightBtn`
    : `${classes.submit} purpleLightBtn`;

    return (
        <div className={classes.LoginContainer}>
        <div className={classes.formContainer}>
        <form onSubmit={submitHandler} className={classes.form}>
        <div className={classes.logo}>
            <img src={logo} alt="logo" />
        </div>
        <h1 className={classes.title}>Reset Password</h1>
        <p className={classes.subtitle}>Enter a new password</p>
        <div className={classes.box}>
          <div className={classes.passwordContainer}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder='Enter your password'
              value={enteredPassword}
              onChange={passwordInputChangeHandler}
              onBlur={passwordInputBlurHandler}
            />
              {passwordInputIsInvalid && <p className={`${classes.invalid} ${passwordInputIsInvalid ? `${classes.isVisible}` : ''}`}>
                Enter a valid password
              </p>
              }
          </div>
          <div className={classes.confirmPasswordContainer}>
            <label htmlFor="confirm">Confirm Password </label>
            <input
              id="confirmPassword"
              type="password"
              placeholder='Re-enter your password'
              value={enteredConfirmPassword}
              onChange={confirmPasswordInputChangeHandler}
              onBlur={confirmPasswordInputBlurHandler}
            />
              {confirmPasswordInputIsInvalid && <p className={`${classes.invalid} ${confirmPasswordInputIsInvalid ? `${classes.isVisible}` : ''}`}>
                Password didnot match
              </p>}
          </div>
          <button disabled={!submitFormValid}  className={`${formInputClasses} ${classes.signInBtn}`}>
            Submit
          </button>
        </div>
        <div className={classes.backToLogin}>
          
        </div>
      </form>
            </div>
            {/* <div className={classes.bottomText}>
            © Copyright 2025 All Rights Reserved Magic Motorsports
            </div>  */}
        </div>
    )
}

export default PasswordResetForm;